export default "__VITE_ASSET__ls9RGa6B__"